<div class="page">

  <!-- Header -->
  <div class="page-header">
    <div class="header-left">
      <button class="btn-back" (click)="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
        Back
      </button>
      <div>
        <h1>{{ user?.name || 'User Detail' }}</h1>
        <p>{{ user?.email || '' }}</p>
      </div>
    </div>
    <div class="header-actions" *ngIf="user && !isEditMode">
      <button class="btn-secondary" (click)="enableEdit()">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
        Edit
      </button>
      <button class="btn-danger" (click)="confirmDelete()">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
          <path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
        </svg>
        Delete
      </button>
    </div>
  </div>

  <!-- Loading -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="spinner-lg"></div>
    <p>Loading user...</p>
  </div>

  <ng-container *ngIf="!isLoading && user">

    <!-- Success Toast -->
    <div class="toast-success" *ngIf="successMessage">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
      {{ successMessage }}
    </div>

    <!-- ── VIEW MODE ── -->
    <div *ngIf="!isEditMode">
      <div class="detail-card">
        <div class="detail-section">
          <h2 class="section-title">User Info</h2>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">Name</span>
              <span class="info-value">{{ user.name || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Email</span>
              <span class="info-value">{{ user.email || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Phone</span>
              <span class="info-value">
                <ng-container *ngIf="user.country_code && user.phone_number; else fullPhone">
                  <span class="country-badge">{{ user.country_code }}</span>
                  {{ user.phone_number }}
                </ng-container>
                <ng-template #fullPhone>{{ user.phone || '—' }}</ng-template>
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">Gender</span>
              <span class="info-value">{{ user.gender ? (user.gender | titlecase) : '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Date of Birth</span>
              <span class="info-value">{{ user.date_of_birth ? (user.date_of_birth | date:'mediumDate') : '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Country</span>
              <span class="info-value">{{ user.country || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">City</span>
              <span class="info-value">{{ user.city || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Preferred Language</span>
              <span class="info-value">{{ user.preferred_language || '—' }}</span>
            </div>
          </div>
        </div>

        <div class="detail-divider"></div>

        <div class="detail-section">
          <h2 class="section-title">Account</h2>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">Auth Provider</span>
              <span class="provider-badge provider-{{ user.auth_provider || 'phone' }}">
                {{ (user.auth_provider || 'phone') | titlecase }}
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">Social Login</span>
              <span class="badge" [class.badge-active]="user.is_social_login" [class.badge-inactive]="!user.is_social_login">
                {{ user.is_social_login ? 'Yes' : 'No' }}
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">Type</span>
              <span class="type-badge type-{{ user.user_type }}">{{ user.user_type | titlecase }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Profile Status</span>
              <span class="badge" [class.badge-active]="user.is_profile_complete" [class.badge-inactive]="!user.is_profile_complete">
                {{ user.is_profile_complete ? 'Complete' : 'Incomplete' }}
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">Account Status</span>
              <span class="badge" [class.badge-active]="user.is_active" [class.badge-inactive]="!user.is_active">
                {{ user.is_active ? 'Active' : 'Inactive' }}
              </span>
            </div>
            <div class="info-item" *ngIf="user.user_type === 'customer'">
              <span class="info-label">Verified lister</span>
              <span class="info-value">
                <span class="badge" [class.badge-active]="user.seller_verified" [class.badge-inactive]="!user.seller_verified">
                  {{ user.seller_verified ? 'Verified' : 'Not verified' }}
                </span>
                <button class="btn-secondary verify-btn" type="button" (click)="toggleSellerVerified()" [disabled]="isVerifying">
                  {{ user.seller_verified ? 'Remove verification' : 'Mark as verified' }}
                </button>
              </span>
              <small class="verify-note">Tick this only after checking their identity and ownership documents. It powers “Verified sellers only” in search.</small>
            </div>
            <div class="info-item" *ngIf="user.referral_code">
              <span class="info-label">Referral Code</span>
              <span class="info-value">{{ user.referral_code }}</span>
            </div>
            <div class="info-item" *ngIf="user.created_at">
              <span class="info-label">Created</span>
              <span class="info-value">{{ user.created_at | date:'mediumDate' }}</span>
            </div>
            <div class="info-item" *ngIf="user.updated_at">
              <span class="info-label">Last Updated</span>
              <span class="info-value">{{ user.updated_at | date:'mediumDate' }}</span>
            </div>
          </div>
        </div>

        <div class="detail-divider"></div>

        <!-- ── Favourites ── -->
        <div class="detail-section">
          <h2 class="section-title">
            Favourites
            <span class="favs-count-badge" *ngIf="favsTotal > 0">{{ favsTotal }}</span>
          </h2>

          <!-- Loading -->
          <div class="favs-loading" *ngIf="favsLoading">
            <div class="spinner-sm"></div>
            <span>Loading favourites…</span>
          </div>

          <ng-container *ngIf="!favsLoading">

            <!-- Grid -->
            <div class="favs-grid" *ngIf="favorites.length > 0">
              <div class="fav-card" *ngFor="let fav of favorites"
                (click)="fav.property && goToProperty(fav.property.id)">

                <!-- Cover -->
                <div class="fav-cover">
                  <img *ngIf="fav.property?.images?.length"
                    [src]="fav.property!.images[0]" [alt]="fav.property!.title" class="fav-img" />
                  <div *ngIf="!fav.property?.images?.length" class="fav-placeholder">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                      <polyline points="9 22 9 12 15 12 15 22"/>
                    </svg>
                  </div>
                  <span class="fav-heart">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24"
                      fill="currentColor">
                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                    </svg>
                  </span>
                </div>

                <!-- Body -->
                <div class="fav-body">
                  <p class="fav-title" dir="rtl">{{ fav.property?.title || '—' }}</p>
                  <div class="fav-meta">
                    <span class="fav-type" *ngIf="fav.property?.property_type">{{ fav.property!.property_type }}</span>
                    <span class="fav-price" *ngIf="fav.property?.price">{{ formatPrice(fav.property!.price) }}</span>
                  </div>
                  <p class="fav-date">Saved {{ fav.created_at | date:'mediumDate' }}</p>
                </div>

              </div>
            </div>

            <p class="no-content" *ngIf="favorites.length === 0">No favourites yet.</p>

            <!-- Pagination -->
            <div class="favs-pagination" *ngIf="favsTotal > favsLimit">
              <div class="pagination-info">
                Showing <strong>{{ favsRangeStart }}–{{ favsRangeEnd }}</strong> of <strong>{{ favsTotal }}</strong>
              </div>
              <div class="pagination-controls">
                <button class="page-btn page-btn-nav" (click)="favsGoToPage(favsPage - 1)" [disabled]="favsPage === 1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"/>
                  </svg>
                </button>
                <ng-container *ngFor="let p of favsPageNumbers">
                  <span class="page-gap" *ngIf="p === -1">…</span>
                  <button *ngIf="p !== -1" class="page-btn"
                    [class.page-btn-active]="p === favsPage"
                    (click)="favsGoToPage(p)">{{ p }}</button>
                </ng-container>
                <button class="page-btn page-btn-nav" (click)="favsGoToPage(favsPage + 1)" [disabled]="favsPage === favsTotalPages">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                </button>
              </div>
              <div class="pagination-size">
                <label>Per page</label>
                <select [(ngModel)]="favsLimit" (change)="favsOnPageSizeChange()">
                  <option *ngFor="let s of favsPageSizes" [ngValue]="s">{{ s }}</option>
                </select>
              </div>
            </div>

          </ng-container>
        </div>

      </div>
    </div>

    <!-- ── EDIT MODE ── -->
    <div *ngIf="isEditMode">
      <div class="error-msg" *ngIf="errorMessage">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        {{ errorMessage }}
      </div>

      <form class="form-card" (ngSubmit)="saveEdit()">
        <div class="form-section">
          <h2 class="section-title">Edit User</h2>

          <div class="form-row">
            <div class="form-group">
              <label>Status</label>
              <div class="toggle-wrap">
                <label class="toggle">
                  <input type="checkbox" [(ngModel)]="editIsActive" name="editIsActive" />
                  <span class="slider"></span>
                </label>
                <span class="toggle-label">{{ editIsActive ? 'Active' : 'Inactive' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="form-divider"></div>

        <div class="form-actions">
          <button type="button" class="btn-secondary" (click)="cancelEdit()">Cancel</button>
          <button type="submit" class="btn-primary" [disabled]="isSubmitting">
            <span *ngIf="!isSubmitting">Save Changes</span>
            <span *ngIf="isSubmitting" class="spinner-sm"></span>
          </button>
        </div>
      </form>
    </div>

  </ng-container>

  <!-- ── Delete Confirmation Modal ── -->
  <div class="modal-overlay" *ngIf="showDeleteModal">
    <div class="modal-confirm">
      <div class="modal-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
          <path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
        </svg>
      </div>
      <h3>Delete User</h3>
      <p>Are you sure you want to delete <strong>{{ user?.name }}</strong>? This action cannot be undone.</p>
      <div class="modal-btns">
        <button class="btn-secondary" (click)="cancelDelete()">Cancel</button>
        <button class="btn-danger-solid" (click)="deleteUser()" [disabled]="isDeleting">
          <span *ngIf="!isDeleting">Yes, Delete</span>
          <span *ngIf="isDeleting" class="spinner-sm"></span>
        </button>
      </div>
    </div>
  </div>

</div>
